module.exports = __webpack_public_path__ + "static/media/chat.80a303a5.svg";